import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Header } from './Header';
import { Footer } from './Footer';
import { ConversationHistory } from './ConversationHistory';
import { ConversationContext } from '../contexts/ConversationContext';
import { backendProxy } from '../hooks/backendProxy';
import { useSessionStorage } from 'usehooks-ts';
import { TopTilesTester } from '../test-tools/TopTilesTester';
import { RelatedSitesTester } from '../test-tools/RelatedSitesTester';
import { TopQuestionsTester } from '../test-tools/TopQuestionsTester';

const ContentPanelDiv = styled.div`
    display: flex; flex-flow: column; justify-content: space-between; 
    height: calc(100% - 50px); max-width: 100%;
    margin-left: auto; margin-right: auto;
    background-color: #fff;  padding: 30px 50px 20px 50px; font-size: 16px;
    @media (min-width: 1080px) {
        width: 980px;
    }
    @media (max-width: 991px) {
        padding: 30px 30px 20px 30px;
    }
    @media (max-width: 768px) {
        height: calc(100% - 20px); padding: 10px 15px;
    }
    p {
        line-height: 19.2px; margin-bottom: 19.2px;
        @media (max-width: 768px) {
            margin-bottom: 14px;
        }
    }
    &.initializing {
        .initializing-panel {
            max-width: calc(100% - 80px);
            background: #fff;
            padding: 20px 0 20px 80px;
            font-size: 20px;
            font-weight: bold;
            color: #000;
            opacity: 0.6;
            overflow: hidden;
            white-space: nowrap;
            display: inline-block;
            position: relative;
            width: 0;
            animation: typing 6s steps(52) forwards;
            .dots::after {
                content: '';
                animation: dot-blink 1.5s steps(1) infinite;
            }
        }
        .conversation-panel {
            display: none;
        }
        .footer {
            opacity: 0.2; pointer-events: none;
        }
    }
    /* Animation für die Schreibmaschinen-Animation */
    @keyframes typing {
        0% {
            width: 0;
        }
        100% {
            width: calc(100% - 80px);
        }
    }
    /* Punkt-Animation für die drei Punkte */
    @keyframes dot-blink {
        0% {
            content: '';
        }
        30% {
            content: '.';
        }
        60% {
            content: '..';
        }
        90% {
            content: '...';
        }
    }
`

export const ContentPanel: React.FC = () => {
    const { clientId, conversationState, messages, testPhaseExpiredMode } = useContext(ConversationContext);
    const [loadedAt, setLoadedAt] = useSessionStorage('loadedAt', 0);
    const [arrivedAt, setArrivedAt] = useState(new Date());
    const contentPanelClass = conversationState === 'initializing' ? 'initializing' : '';
    useEffect(() => {
        if (!loadedAt) {
            setLoadedAt(new Date().getTime());
            backendProxy.trackEvent('app-start', clientId, { messagesCount: messages.length });
        }
    });

    useEffect(() => {
        window.onbeforeunload = function (e) {
            const now = new Date();
            const wasHereFor = Math.floor((now.getTime() - arrivedAt.getTime()) / 1000);
            const tabExistsFor = Math.floor((now.getTime() - loadedAt) / 1000);
            backendProxy.trackEvent('app-close', clientId, { wasHereFor, tabExistsFor, messagesCount: messages.length });
            e.stopImmediatePropagation();
            return undefined;
        };
        
        window.onfocus = function () {
            const now = new Date();
            const wasAwayFor = Math.floor((now.getTime() - arrivedAt.getTime()) / 1000);
            const tabExistsFor = Math.floor((now.getTime() - loadedAt) / 1000);
            backendProxy.trackEvent('app-gain-focus', clientId, { wasAwayFor, tabExistsFor, messagesCount: messages.length });
            setArrivedAt(now);
        }
        window.onblur = function () {
            const now = new Date();
            const wasHereFor = Math.floor((now.getTime() - arrivedAt.getTime()) / 1000);
            const tabExistsFor = Math.floor((now.getTime() - loadedAt) / 1000);
            backendProxy.trackEvent('app-lose-focus', clientId, { wasHereFor, tabExistsFor, messagesCount: messages.length });
        }
    })
    return (
        <ContentPanelDiv className={contentPanelClass}>
            <Header />
            { 
            window.location.search.indexOf("topTilesTester") >= 0 
            ?
                <div style={{height: '100%'}}><TopTilesTester /></div>
            :
            window.location.search.indexOf("topQuestionsTester") >= 0 
            ?
                <div style={{height: '100%'}}><TopQuestionsTester /></div>
            :
            window.location.search.indexOf("relatedSitesTester") >= 0 
            ?
                <div style={{height: '100%'}}><RelatedSitesTester /></div>
            :
                <>
                <ConversationHistory />
                { !testPhaseExpiredMode && 
                    <Footer />
                }
                </>
            }
        </ContentPanelDiv>
    )
}